import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { connect } from 'react-redux';
import { setDocUploadStartTime } from '../actions/documents';
import { setFile as _setFile } from '../actions/file';
import { subscribeToChannel } from '../actions/pusher';
import { tagFunnel as _tagFunnel, tagPageview } from '../actions/tagmanager';
import { toggle } from '../actions/ui';
import { MY_COMPUTER } from '../util/dataTestIds';
import { UploadComputerButton, ComputerFileInput, LaptopIcon } from '../styles';
import { COMPUTER_BUTTON_COPY, COMPUTER_LABEL_COPY } from '../constants';
export function checkFile(uploadConfig, file) {
  var fileExtension = ".".concat(file.name.split('.').pop());
  if (uploadConfig.extensions.indexOf(fileExtension) === -1) {
    return 'alertFileType';
  }
  if (file.size > uploadConfig.filesize.max) {
    return 'alertFileSize';
  }
  return null;
}
export var DocumentUpload = function DocumentUpload(_ref) {
  var initialized = _ref.initialized,
    uploadConfig = _ref.uploadConfig,
    openCheckModal = _ref.openCheckModal,
    showError = _ref.showError,
    buttonAttributes = _ref.buttonAttributes,
    tagFunnel = _ref.tagFunnel,
    setFile = _ref.setFile,
    upload = _ref.upload,
    onComputerCtaClicked = _ref.onComputerCtaClicked;
  var inputRef = React.useRef(null);
  var handleChange = function handleChange(event) {
    var target = event.target;
    var file = target.files[0];
    var error = checkFile(uploadConfig, file);
    if (error) {
      return showError(error);
    }
    openCheckModal();
    setFile(file);
    upload();
  };
  var handleClick = function handleClick() {
    onComputerCtaClicked && onComputerCtaClicked();
    selectFile();
  };
  var selectFile = function selectFile() {
    var _inputRef$current;
    return (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
  };
  var disabled = !initialized;
  var accept = uploadConfig.extensions.join(',') || '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(UploadComputerButton, _extends({
    id: "upload-computer-button",
    className: "uw__local-upload",
    "aria-label": COMPUTER_LABEL_COPY,
    "data-test-id": MY_COMPUTER,
    onClick: handleClick,
    disabled: disabled
  }, buttonAttributes), /*#__PURE__*/React.createElement(LaptopIcon, {
    name: "laptop"
  }), COMPUTER_BUTTON_COPY), /*#__PURE__*/React.createElement(ComputerFileInput, {
    ref: inputRef,
    "aria-labelledby": "upload-computer-button",
    id: "upload-computer",
    type: "file",
    tabIndex: -1,
    accept: accept,
    disabled: disabled,
    onChange: handleChange,
    onClick: function onClick() {
      uploadConfig && tagFunnel('upload paper', 'on my computer');
    }
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    initialized: state.app.initialized,
    uploadConfig: state.app.upload,
    file: state.file
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openCheckModal: function openCheckModal() {
      dispatch(tagPageview('/virtual-pageview/paperchecker/processing-your-paper'));
      dispatch(setDocUploadStartTime());
    },
    showError: function showError(key) {
      return dispatch(toggle(key, true));
    },
    // instead of stale reference to uploadStartTime in react component, createDocument action
    // retrieves second argument from store
    tagFunnel: function tagFunnel(eventName, eventAction) {
      dispatch(_tagFunnel(eventName, eventAction));
    },
    setFile: function setFile(file) {
      return dispatch(_setFile(file));
    },
    upload: function upload() {
      return dispatch(subscribeToChannel());
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(DocumentUpload);